import { render } from "./DetailProsesGesiap.vue?vue&type=template&id=7f930f4f"
import script from "./DetailProsesGesiap.vue?vue&type=script&lang=js"
export * from "./DetailProsesGesiap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__